import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import BlackWhiteButton from "../../../components/buttons/BlackWhiteButton";
import AddButton from "../../../components/buttons/AddButton";
import EyeBlock from "../../../assets/img/eye_block.svg";
import EyeOpen from "../../../assets/img/eye_open.svg";
import {
  List,
  ListHeader,
  ListHeaderItem,
  ListHeaderItemDropdown,
  ListBody,
  ListBodyCell,
  ListBodyItem,
  ListBodyItemAction,
  ListBodyItemSwitch,
} from "../../../components/_widgets/WidgetsList";
import { formatDate, getTeamAll } from "../../../config/utils";
import { decodeToken } from "../../../config/auth";
import api from "../../../config/api";
import { Success, ConfirmDelete } from "../../../components/Alert";
import AddNewCollaborators from "./components/addNewCollaborators";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";
require("dotenv").config();

function Team() {
  const [team, setTeam] = useState([]);
  const [user, setUser] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [regexPassword, setRegexPassword] = useState(false);

  // Filters
  const [teamAll, setTeamAll] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  // Pagination
  const [qtLimitItem, setQtLimitItem] = useState(10);
  const [pageItemsList, setPageItemsList] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTeam(pageItemsList, qtLimitItem, selectedUser, nameFilter, selectedStatus);
    getAllTeam();
  }, []);

  const getTeam = async (page, qtLimitItem, selectedUser, nameFilter, selectedStatus) => {
    try {
      const response = await api.get(
        `/user?paginate=true&role=admin&limit=${qtLimitItem}&page=${page}&selectedUser=${selectedUser}&name=${nameFilter}&status=${selectedStatus}`
      );
      setTeam(response.data.docs);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUserChange = (event) => {
    setUser((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const selectImageNewUser = (e) => {
    if ((e !== undefined) & (e !== null)) {
      if (e.target.files && e.target.files[0]) {
        setUser((values) => ({
          ...values,
          avatar: URL.createObjectURL(e.target.files[0]),
        }));
        setUser((values) => ({ ...values, file: e.target.files[0] }));
      }
    }
  };

  const deleteUser = async (id) => {
    const response = await api.delete(`/user-adm/${id}`).then((resp) => {
      getTeam(pageItemsList, qtLimitItem, selectedUser, nameFilter, selectedStatus);
    });
  };

  // Filter
  const getAllTeam = async () => {
    let response = await getTeamAll();
    setTotalItems(response.total);
    setTeamAll(response.list);
  };

  const handleSelectUser = (value) => {
    setSelectedUser(value);
    getTeam(pageItemsList, qtLimitItem, value, nameFilter, selectedStatus);
  };

  const handleInputFilter = (value) => {
    setNameFilter(value);
    getTeam(pageItemsList, qtLimitItem, selectedUser, value, selectedStatus);
  };

  const handleSelectStatus = (value) => {
    setSelectedStatus(value);
    getTeam(pageItemsList, qtLimitItem, selectedUser, nameFilter, value);
  };

  const show = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const showConfirm = (e) => {
    e.preventDefault();
    setShowConfirmPassword(!showConfirmPassword);
  };

  // Pagination
  const setLimitList = (value) => {
    setQtLimitItem(value);
    setPageItemsList(1);
    getTeam(1, value, selectedUser, nameFilter, selectedStatus);
  };

  const changePage = (event) => {
    setPageItemsList(event.target.id);
    getTeam(event.target.id, qtLimitItem, selectedUser, nameFilter, selectedStatus);
  };

  const prevButton = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
      getTeam(pageItemsList - 1, qtLimitItem, selectedUser, nameFilter, selectedStatus);
    }
  };

  const nextButton = () => {
    let qtPages = Math.ceil(totalItems / qtLimitItem);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(pageItemsList + 1);
      getTeam(pageItemsList + 1, qtLimitItem, selectedUser, nameFilter, selectedStatus);
    }
  };

  // Change status
  const handleStatus = async (item) => {
    if (item.status === "disabled") {
      item.status = "active";
    } else {
      item.status = "disabled";
    }
    await api.put(`/user/${item._id}`, item);
    getTeam(pageItemsList, qtLimitItem, selectedUser, nameFilter, selectedStatus);
  };

  const handleUserSubmit = async (e) => {
    e.preventDefault();
    if (!user.name) {
      return swal("Error!", "Digite um nome", "error");
    }
    if (!user.phone) {
      return swal("Error!", "Digite um celular", "error");
    }
    if (!user.email) {
      return swal("Error!", "Digite um email", "error");
    }
    if (!regexPassword) {
      return swal(
        "Error!",
        "As senhas devem ter no mínimo 8 caracteres contendo uma letra, um número e um caracter especial",
        "error"
      );
    }

    if (user.password === user.confirmPassword) {
      const dataup = new FormData();
      dataup.append("file", user.file);
      dataup.append("phone", user.phone);
      dataup.append("name", user.name);
      dataup.append("role", "admin");
      dataup.append("password", user.password);
      dataup.append("email", user.email);

      if (user._id === undefined || user._id === null) {
        await api
          .post(`/user`, dataup, {
            headers: {
              "content-type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.success) {
              setOpenDrawer(false);
              resetUserFields();
              getTeam(pageItemsList, qtLimitItem, selectedUser, nameFilter, selectedStatus);
              swal("Sucesso!", "Usuário cadastrado com sucesso!", "success");
            }
            if (res.data.error) {
              swal("Error!", res.data.message, "error");
            }
          })
          .catch((e) => {
            console.log(e);
            swal("Error!", "Verifique os dados enviados", "error");
          });
      } else {
        try {
          const res = await api.put(`/user/${user._id}`, dataup, {
            headers: {
              "content-type": "multipart/form-data",
            },
          });
          console.log(JSON.stringify(res));
          if (res.data.success) {
            setOpenDrawer(false);
            resetUserFields();
            getTeam(pageItemsList, qtLimitItem, selectedUser, nameFilter, selectedStatus);
            swal("Sucesso!", "Usuário alterado com sucesso!", "success");
          }
          if (res.data.error) {
            swal("Error!", res.data.message, "error");
          }
        } catch (e) {
          console.log(e);
          swal("Error!", "Verifique os dados enviados", "error");
        }
      }
    } else {
      return swal("Error!", "As senhas não coincidem", "error");
    }
  };
  const resetUserFields = () => {
    setUser({
      name: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      avatar: "",
    });
  };
  return (
    <>
      <Layout defaultMenu={2} title={"Time"} link={""}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="d-flex flex-column flex-lg-row justify-content-between">
            <div className="col-12 col-lg-3 mt-2">
              <div className="input-group input-search mb-3 d-flex align-items-center">
                <input
                  value={nameFilter}
                  onChange={({ target }) => handleInputFilter(target.value)}
                  type="text"
                  className="form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto"
                  placeholder="Buscar"
                />
                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search text-cl-auroMetal"></i>
                </span>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              {/* <BlackWhiteButton className="me-5" size={6} sizeLg={"auto"} text="Exportar planilha" /> */}
              <AddButton
                size={6}
                sizeLg={"auto"}
                text="Adicionar colaborador"
                onClick={() => {
                  resetUserFields();
                  setOpenDrawer(true);
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-column flex-lg-row pb-4">
            <List
              section={"colaboradores"}
              onChange={(e) => setLimitList(e.target.value)}
              limit={qtLimitItem}
              totalItem={totalItems}
              page={pageItemsList}
              prevButton={() => prevButton()}
              nextButton={() => nextButton()}
              changePage={(e) => changePage(e)}
            >
              <ListHeader>
                <ListHeaderItem sizeLg={3} title={"Nome"}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por estabelecimento"}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div key={"all"} onClick={() => handleSelectUser("")} className="dropdown-item">
                        <span>Todos</span>
                      </div>
                      {teamAll.map((item, index) => (
                        <div key={index} onClick={() => handleSelectUser(item._id)} className="dropdown-item">
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={3} title={"Data de adição"} />
                <ListHeaderItem sizeLg={6} title={"Status"}>
                  <ListHeaderItemDropdown>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      {[
                        { name: "Todos", value: "" },
                        { name: "Ativo", value: "active" },
                        { name: "Inativo", value: "disabled" },
                      ].map((item, index) => (
                        <div key={index} onClick={() => handleSelectStatus(item.value)} className="dropdown-item">
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
              </ListHeader>
              <ListBody>
                {loading ? (
                  <>
                    <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ height: "8rem", width: "8rem", borderWidth: "0.8em" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  </>
                ) : (
                  <>
                    {team.length ? (
                      <>
                        {team.map((item, index) => (
                          <ListBodyCell
                            key={index}
                            className={`${index % 2 !== 0 ? "bg-cl-cultured" : ""} hover-adm c-pointer`}
                          >
                            <ListBodyItem
                              onClick={() => {
                                setUser(item);
                                setOpenDrawer(true);
                              }}
                              sizeLg={3}
                              description={"Nome"}
                              title={item.name}
                            />
                            <ListBodyItem
                              onClick={() => {
                                setUser(item);
                                setOpenDrawer(true);
                              }}
                              sizeLg={3}
                              description="Data de adição"
                              title={formatDate(item.createdAt)}
                            />
                            <ListBodyItemSwitch
                              sizeLg={5}
                              onClick={() => handleStatus(item)}
                              value={item.status === "disabled" ? false : true}
                            />
                            <ListBodyItemAction sizeLg={1} title={"edit"}>
                              <li
                                onClick={() => {
                                  setUser(item);
                                  setOpenDrawer(true);
                                }}
                              >
                                <span className="dropdown-item fz-14 ff-univanova-regular c-pointer  text-cl-azure">
                                  Editar
                                </span>
                              </li>
                              <li
                                onClick={() => {
                                  deleteUser(item._id);
                                }}
                              >
                                <span className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer  text-cl-red">
                                  Excluir
                                </span>
                              </li>
                            </ListBodyItemAction>
                          </ListBodyCell>
                        ))}
                      </>
                    ) : (
                      <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
                        <span> Nenhum colaborador cadastrado</span>
                      </div>
                    )}
                  </>
                )}
              </ListBody>
            </List>
          </div>
        </div>
        <AddNewCollaborators
          {...{
            setOpenDrawer,
            openDrawer,
            handleUserSubmit,
            user,
            selectImageNewUser,
            handleUserChange,
            showPassword,
            show,
            EyeOpen,
            EyeBlock,
            showConfirmPassword,
            showConfirm,
            setRegexPassword,
          }}
        />
      </Layout>

      <button id="btnCallSuccessPostUser" className="d-none" data-bs-toggle="modal" data-bs-target="#SuccessPostUser">
        Chamar modal success
      </button>
      <Success id="SuccessPostUser" title={"Colaborador inserido com sucesso!"} />
    </>
  );
}

export default Team;
